<script lang="ts">import { Button } from "@infinitro/button";
import { stateUi } from "@infinitro/config";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import { createEventDispatcher, onMount } from "svelte";
import { get } from "svelte/store";
export let tabs = [];
export let activeTab = tabs.length > 0 ? tabs[0].value : "";
export let width = null;
export let size = "large";
export let notSameSize = false;
export let preserveScrollPosition = false;
export let saveScrollPosition = null;
export let borderRadius = undefined;
export let borderRadiusContainer = undefined;
export let shouldScrollIntoView = true;
let tabsContainer;
let tabElements = [];
const dispatch = createEventDispatcher();
$: compactTabRadii = $stateUi.tabs?.useCompactTabStripRadius ?? false;
$: resolvedBorderRadius = borderRadius ?? (compactTabRadii ? "8px" : "14px");
$: resolvedBorderRadiusContainer = borderRadiusContainer ?? (compactTabRadii ? "12px" : "16px");
$: buttonVariant = $stateUi.tabs?.tabButtonsDefaultVariant ?? "secondary";
function handleTabClick(event, value) {
	if (preserveScrollPosition && saveScrollPosition) {
		saveScrollPosition(window.scrollY);
	}
	activeTab = value;
	const index = tabs.findIndex((tab) => tab.value === value);
	const tab = tabs[index];
	dispatch("change", {
		index,
		value,
		tab
	});
	const tabElement = event.target;
	if (shouldScrollIntoView) {
		tabElement.scrollIntoView({
			behavior: "smooth",
			block: "nearest",
			inline: "center"
		});
	}
}
onMount(() => {
	const index = tabs.findIndex((tab) => tab.value === activeTab);
	const activeTabElement = tabElements[index];
	if (shouldScrollIntoView && activeTabElement instanceof HTMLElement && tabsContainer) {
		activeTabElement.scrollIntoView({
			behavior: "smooth",
			inline: "center",
			block: "nearest"
		});
	}
});
</script>

<div
	class="tabs"
	style="width: {width ? width : 'auto'}; border-radius: {resolvedBorderRadiusContainer}"
	bind:this={tabsContainer}
>
	{#each tabs as tab, index}
		{#if (tab.link && tab.url) || (!tab.link && tab.value)}
			<a
				href={tab.url ? toSiteUrl(tab.url, $loggedIn) : 'javascript:void(0);'}
				style="text-decoration: none; cursor: pointer; width: 100%"
				bind:this={tabElements[index]}
			>
				<Button
					text={tab.label}
					className="tab {tab.value === activeTab ? 'active' : ''}"
					variant={buttonVariant}
					styleCustom={`border-radius: ${resolvedBorderRadius}; padding-left: 0.5rem; padding-right: 0.5rem;`}
					onClick={(e) => handleTabClick(e, tab.value)}
					minWidth={false}
					icon={$stateUi.layout.useRemoteIcons === true && tab.remoteIcon
						? tab.remoteIcon
						: tab.icon}
					fullWidth={!notSameSize}
					activeTab={tab.value === activeTab}
					inactiveTab={tab.value !== activeTab}
					id={tab.id || tab.value.toString()}
					{size}
					iconCustomStyles="width:20px;height:20px"
					whiteSpace="nowrap"
				>
					<div slot="right-slot">
						{#if tab.quantity}
							<span class="quantity">
								{tab.quantity || 0}
							</span>
						{/if}
					</div>
				</Button>
			</a>
		{/if}
	{/each}
</div>

<style>
	div.tabs {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border-radius: 16px;
}
	.tabs {
		z-index: 10;
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-weight: 800;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(229 231 235 / var(--tw-text-opacity, 1));
		margin-top: 0 !important;
}
	.quantity {
		margin-left: 0.5rem;
		display: flex;
		height: 1rem;
		min-width: 1rem;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		background-color: var(--color-primary-500);
		padding: 0.25rem;
		font-size: 0.55rem;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

	:global(.category-item .tabs a button p) {
		white-space: nowrap;
	}
	:global(.category-item .tabs a) {
		flex: 0;
	}
	:global(.category-item .tabs a button) {
		padding: 0 1rem !important;
	}
</style>
